<template>
    <section class="lymphomap_main">
        <div class="bot_tickets_table">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="main_heading">
                            <button type="button" class="btn back_btn" tapable @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>Bot Tickets
                        </h2>
                    </div>
                    <div class="col-md-auto ml-md-auto bot_tickets_header">
                        <button class="btn btn-primary" @click="createTicketPopupMethod">Create Ticket</button>
                    </div>
                </div>
                <div class="bot_tickets_list mt-3 pt-1 table-responsive">
                    <table class="table" v-if="botTickets">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Category</th>
                                <th>Ticket Number</th>
                                <th>Created Date</th>
                                <th>status</th>
                                <th class="text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="botTicketResults.length > 0">
                            <tr v-for="(item, index) in botTicketResults" :key="index">
                                <td data-label="Title">{{ item.title }}</td>
                                <td data-label="Category">{{ item.category }}</td>
                                <td data-label="Ticket Number">{{ item.ticket_number }}</td>
                                <td data-label="Created Date">{{ item.created_at | LocalDateFormat }} at {{
                                    item.created_at | LocalTimeFormat }}
                                </td>
                                <td data-label="status">
                                    <label class="badge badge-success" v-if="item.status == 'active'">Active</label>
                                    <label class="badge badge-success"
                                        v-else-if="item.status == 'in_progress'">Active</label>
                                    <label class="badge badge-danger" v-else>{{
                                        item.status }}</label>
                                </td>
                                <td class="text-sm-right" data-label="Action">
                                    <template v-if="item.status == 'closed'">
                                        <label class="badge badge-secondary">{{ item.last_message_preview.message
                                            }}</label>
                                    </template>
                                    <button class="btn btn-primary" @click="botTicketsChatMethod(item)" v-else
                                        style="font-size: 16px;padding: 4px 10px;"><i class="fa fa-commenting mr-1"
                                            aria-hidden="true"></i> Chat</button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="7" class="text-center">You don't have any tickets.</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="fixloader" v-else>
                        <div class="spinner spinner-1"></div>
                    </div>
                </div>
            </div>
        </div>
        <bot-ticket-popup v-if="botTicketsPopup"></bot-ticket-popup>
        <bot-tickets-chat-popup v-if="botTicketsChatPopup" :ticketInfo="ticketInfo"></bot-tickets-chat-popup>
    </section>
</template>

<script>
/*eslint-disable */
import createTicketPopup from '@/components/private/bot/create-ticket-popup';
import botTicketsChatPopup from '@/components/private/bot/ticket-help-chat-popup/index.vue';
import { mapGetters } from 'vuex';
import { bus } from '@/main';
export default {
    name: 'bot-tickets',
    components: {
        'bot-ticket-popup': createTicketPopup,
        'bot-tickets-chat-popup': botTicketsChatPopup
    },
    props: [],
    data() {
        return {
            botTickets: null,
            botTicketResults: [],
            botTicketsPopup: false,
            botTicketsChatPopup: false,
            ticketInfo: null
        }
    },
    computed: {
        ...mapGetters([
            'botTicketListGetters',
        ]),
        botTicketList() {
            this.botTickets = this.$store.getters.botTicketListGetters.data;
            return;
        },
        setInitialStatus() {
            if (this.botTickets) {
                this.botTicketResults = this.botTickets.results;
            }
            return;
        },
    },
    mounted() {
        bus.$on('botTicketsPopupBus', (data) => {
            this.botTicketsPopup = data;
        });
        bus.$on('botTicketsChatPopupBus', (data) => {
            this.botTicketsChatPopup = data;
        });
    },
    methods: {
        botTicketsChatMethod(info) {
            this.botTicketsChatPopup = true;
            this.ticketInfo = info;
        },
        createTicketPopupMethod() {
            this.botTicketsPopup = true;
        }
    },
    watch: {
        botTicketList() {
            return this.$store.getters.botTicketListGetters;
        },
        setInitialStatus() {
            if (this.botTickets) {
                this.botTicketResults = this.botTickets.results;
            }
            return;
        },
    }
}

</script>

<style lang="scss" scoped>
.bot_tickets_table {
    color: #ffffff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .top_brd {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .main_heading {
        color: #ffffff;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        box-shadow: none !important;
        background: rgba(255, 255, 255, 0.12);
        color: #ffffff;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;

        &:hover {
            background: #87cefa !important;
            color: #000 !important;
            border-color: #87cefa !important;
        }
    }

    .bot_tickets_list {
        .table {
            margin-bottom: 0;
            letter-spacing: 0.5px;
            color: #ffffff;
            border-collapse: separate;
            border-spacing: 0 3px;

            >thead>tr {
                background: rgba(228, 233, 237, .1);
                align-items: end;
            }

            >thead tr {
                align-items: end;
            }

            >thead th {
                border-bottom: 0;
                font-size: 19px;
                padding: 10px 8px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                text-transform: uppercase;
                border-top: 0px;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                color: #87cefa;
                word-spacing: 5px;
            }

            >thead .empty_cell th {
                padding: 0px !important;
                background: none !important;
            }

            >tbody tr td {
                color: #ffffff;
                vertical-align: top;
                padding: 20px 8px;
                font-size: 20px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border-top: 0px;
                background: rgba(228, 233, 237, .1);

                .badge {
                    font-weight: normal;
                    text-transform: capitalize;
                    font-size: 16px;
                }
            }

            a:hover {
                text-decoration: none;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .bot_tickets_list {

            table,
            thead,
            tbody,
            th,
            td,
            tr {
                display: block;
            }

            thead tr {
                position: absolute;
                top: -9999px;
                left: -9999px;
            }

            tr {
                border: 1px solid rgba(228, 233, 237, 0.22);
                margin-bottom: 8px;
                border-radius: 5px;
            }

            td {
                border: none;
                border-bottom: 1px solid rgba(228, 233, 237, 0.05);
                background: rgba(228, 233, 237, 0.08);
                position: relative;
                padding: 5px 8px 5px 45% !important;
                font-size: 14px !important;

                &[colspan] {
                    padding-left: 0px !important;
                }

                &:last-child {
                    border-bottom: 0;
                }

                &::before {
                    content: attr(data-label);
                    position: absolute;
                    left: 6px;
                    width: 45%;
                    padding-right: 10px;
                    white-space: nowrap;
                    text-align: left;
                    font-weight: bold;
                    font-size: 16px;
                    color: #87cefa;
                }

                .badge {
                    font-size: 14px !important;
                    word-break: break-word;
                    white-space: normal;
                    line-height: 1.2;
                }
            }
        }

        .bot_tickets_header {
            margin-top: 10px;

            .btn {
                font-size: 16px;
                padding: 5px 10px;
            }
        }
    }
}
</style>